import React from "react";
import styles from "./LocationTableRow.module.css";
import classnames from "classnames";
import {Actions} from "../../../../elements/actions/Actions";
import {LocationInListDTO} from "../../../../../api/generated";
import {FormName} from "../../../../elements/formProvider/formSlice";
import {PopupModalName} from "../../../../elements/popupModalProvider/popupModalSlice";
import {Link} from "react-router-dom";

interface LocationTableRowProps {
    index: number
    location: LocationInListDTO
    isLastRow: boolean
}


export const LocationTableRow: React.FC<LocationTableRowProps> = ({
                                                                      index,
                                                                      location,
                                                                      isLastRow
                                                                  }) => {

    const publicId = location.publicId;

    return <div
        key={index}
        className={classnames(
            styles.wrapper,
            isLastRow && styles.lastRow,
            location.hasWarnings && styles.hasWarning
        )}
    >
        <Link className={styles.rowLink} to={`/locations/${publicId}`}>
            <span className={styles.locationIdCell}>{location.publicId}</span>
            <span className={styles.nameCell}>{location.name}</span>
            <span className={styles.cityCell}>{location.city}</span>
            <span className={styles.postcodeCell}>{location.postcode}</span>
        </Link>
        <span className={styles.actionsCell} onClick={event => event.stopPropagation()}>
            <Actions
                index={index}
                publicId={location.publicId}
                editFormName={FormName.UPDATE_LOCATION}
                deleteModalName={PopupModalName.DELETE_LOCATION}
                canBeDeleted={location.canBeDeleted}
                entityName={location.name}
            />
        </span>
    </div>
}
